/* eslint-disable no-case-declarations */
/* eslint-disable default-param-last */
import { Reducer } from 'redux';
import produce from 'immer';
import { JuridicoFacilTypes, JuridicoFacilState } from './types';

const INITIAL_STATE: JuridicoFacilState = {
  juridico: {
    recomendados: [],
    tipo_para_index: [],
    area_para_index: [],
    tema_para_index: [],
    mais_vistos: [],
    video: '',
    conteudo: [],
    textos: [],
    referencia_legal: [],
    lista_tipos: [],
    lista_areas: [],
    lista_temas: [],
    lista_subtemas: [],
    acervo: [],
    search_total_page: 1,
    qnt_por_tema_licitacao: [],
    qnt_por_subtema_licitacao: [],
    qnt_por_area_licitacao: [],
    qnt_por_area: [],
    qnt_por_tipo_sumula: 0,
    qnt_por_tipo_jurisprudencia: 0,
    qnt_por_tipo_jurisprudencia_limitada: false,
    qnt_por_tipo_dica: 0,
    qnt_leis: 0,
    leis: [],
    sugestoes: [],
    exibir: [],
    quantidade_por_lei: [],
    total_registros: 0,
    total_page_area: 0,
    video_show: false,
    accept: false,
  },
  request: {
    index: {
      loading: false,
      loaded: false,
      error: false,
    },
    consult: {
      loading: false,
      loaded: false,
      error: false,
    },
    tipos: {
      loading: false,
      loaded: false,
      error: false,
    },
    areas: {
      loading: false,
      loaded: false,
      error: false,
    },
    subtemas: {
      loading: false,
      loaded: false,
      error: false,
    },
    search: {
      loading: false,
      loaded: false,
      error: false,
    },
    legislation: {
      loading: false,
      loaded: false,
      error: false,
    },
    law: {
      loading: false,
      loaded: false,
      error: false,
    },
    search_law: {
      loading: false,
      loaded: false,
      error: false,
    },
    areas_subtopics: {
      loading: false,
      loaded: false,
      error: false,
    },
    tema_area: {
      loading: false,
      loaded: false,
      error: false,
    },
  },
};
const reducer: Reducer<JuridicoFacilState> = (
  state = INITIAL_STATE,
  { type, result, video_ativo, accept },
) => {
  return produce(state, (draft) => {
    switch (type) {
      case JuridicoFacilTypes.GET_INDEX_REQUEST:
        draft.juridico.recomendados = INITIAL_STATE.juridico.recomendados;

        draft.request.index = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case JuridicoFacilTypes.GET_INDEX_SUCCESS:
        draft.juridico.area_para_index = result?.data?.area_para_index;
        draft.juridico.recomendados = result?.data?.recomendados;
        draft.juridico.tipo_para_index = result?.data?.tipo_para_index;
        draft.juridico.tema_para_index = result?.data?.tema_para_index;
        draft.juridico.tribunais_para_index = result?.data?.tribunais_para_index;
        draft.juridico.mais_vistos = result?.data?.mais_vistos;
        draft.juridico.video = result?.data?.video?.dica_em_video;

        draft.request.index = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case JuridicoFacilTypes.GET_INDEX_FAILURE:
        draft.request.index = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case JuridicoFacilTypes.GET_CONSULT_REQUEST:
        // Sem limpar, o item anterior fica em tela até a resposta chegar — e as
        // duas fontes têm campos diferentes, o que deixa o resíduo visível.
        draft.juridico.conteudo = [];
        draft.juridico.textos = [];
        draft.juridico.sugestoes = [];
        draft.request.consult = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case JuridicoFacilTypes.GET_CONSULT_SUCCESS:
        draft.juridico.conteudo = Array(result?.data?.conteudo);
        draft.juridico.textos = result?.data?.textos || [];
        draft.juridico.referencia_legal = result?.data?.referencia_legal;
        draft.juridico.sugestoes = result?.data?.enunciados_relacionados || [];

        draft.request.consult = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case JuridicoFacilTypes.GET_CONSULT_FAILURE:
        draft.request.consult = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case JuridicoFacilTypes.GET_TIPOS_REQUEST:
        draft.request.tipos = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case JuridicoFacilTypes.GET_TIPOS_SUCCESS:
        draft.juridico.lista_tipos = result?.data?.lista_tipos;
        draft.juridico.lista_areas = result?.data?.lista_areas;
        draft.juridico.lista_temas = result?.data?.lista_temas;
        draft.juridico.acervo = result?.data?.acervo;
        draft.juridico.total_page_area = result?.data?.total_entries;
        draft.request.tipos = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case JuridicoFacilTypes.GET_TIPOS_FAILURE:
        draft.request.tipos = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case JuridicoFacilTypes.GET_AREAS_REQUEST:
        draft.request.tipos = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case JuridicoFacilTypes.GET_AREAS_SUCCESS:
        draft.juridico.lista_tipos = result?.data?.lista_tipos;
        draft.juridico.lista_areas = result?.data?.lista_areas;
        draft.juridico.lista_temas = result?.data?.lista_temas;
        draft.juridico.lista_subtemas = result?.data?.lista_subtemas;
        draft.juridico.total_page_area = result?.data?.total_entries;
        draft.juridico.acervo = result?.data?.acervo;
        draft.request.tipos = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case JuridicoFacilTypes.GET_AREAS_FAILURE:
        draft.request.tipos = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case JuridicoFacilTypes.GET_THEMES_REQUEST:
        draft.request.tipos = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case JuridicoFacilTypes.GET_THEMES_SUCCESS:
        draft.juridico.lista_tipos = result?.data?.lista_tipos;
        draft.juridico.lista_areas = result?.data?.lista_areas;
        draft.juridico.lista_temas = result?.data?.lista_temas;
        draft.juridico.acervo = result?.data?.acervo;
        draft.juridico.total_page_area = result?.data?.total_entries;
        draft.request.tipos = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case JuridicoFacilTypes.GET_THEMES_FAILURE:
        draft.request.tipos = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;

      case JuridicoFacilTypes.GET_LIST_SUBTOPICS_REQUEST:
        draft.request.subtemas = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case JuridicoFacilTypes.GET_LIST_SUBTOPICS_SUCCESS:
        draft.juridico.lista_subtemas = result?.data?.lista;
        draft.request.subtemas = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case JuridicoFacilTypes.GET_LIST_SUBTOPICS_FAILURE:
        draft.request.subtemas = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case JuridicoFacilTypes.TYPE_ID_REQUEST:
        draft.request.subtemas = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case JuridicoFacilTypes.TYPE_ID_SUCCESS:
        draft.juridico.acervo = result?.data;
        draft.request.subtemas = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case JuridicoFacilTypes.TYPE_ID_FAILURE:
        draft.request.subtemas = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case JuridicoFacilTypes.SEARCH_REQUEST:
        draft.request.search = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case JuridicoFacilTypes.SEARCH_SUCCESS:
        draft.juridico.acervo = result?.data?.acervo;
        draft.juridico.qnt_por_tema_licitacao = result?.data?.qnt_por_tema_licitacao;
        draft.juridico.qnt_por_subtema_licitacao = result?.data?.qnt_por_subtema_licitacao;
        draft.juridico.qnt_por_area_licitacao = result?.data?.qnt_por_area_licitacao;
        draft.juridico.qnt_por_area = result?.data?.qnt_por_area || [];
        draft.juridico.qnt_por_tipo_sumula = result?.data?.qnt_por_tipo_sumula;
        draft.juridico.qnt_por_tipo_jurisprudencia = result?.data?.qnt_por_tipo_jurisprudencia;
        draft.juridico.qnt_por_tipo_jurisprudencia_limitada =
          result?.data?.qnt_por_tipo_jurisprudencia_limitada || false;
        draft.juridico.qnt_por_tipo_dica = result?.data?.qnt_por_tipo_dica;
        draft.juridico.qnt_leis = result?.data?.qnt_leis;
        draft.juridico.search_total_page = result?.data?.total_entries;
        draft.request.search = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case JuridicoFacilTypes.SEARCH_FAILURE:
        draft.request.search = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case JuridicoFacilTypes.LEGISLATION_REQUEST:
        draft.request.legislation = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case JuridicoFacilTypes.LEGISLATION_SUCCESS:
        draft.juridico.leis = result?.data;
        draft.request.legislation = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case JuridicoFacilTypes.LEGISLATION_FAILURE:
        draft.request.legislation = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case JuridicoFacilTypes.LAW_REQUEST:
        draft.request.law = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case JuridicoFacilTypes.LAW_SUCCESS:
        draft.juridico.leis = Array(result?.data);
        draft.request.law = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case JuridicoFacilTypes.LAW_FAILURE:
        draft.request.law = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case JuridicoFacilTypes.SEARCH_LAW_REQUEST:
        draft.request.search_law = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case JuridicoFacilTypes.SEARCH_LAW_SUCCESS:
        draft.juridico.exibir = result?.data?.exibir;
        draft.juridico.quantidade_por_lei = Array(result?.data?.quantidade_por_lei);
        draft.juridico.total_registros = result?.data?.total_registros;
        draft.request.search_law = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case JuridicoFacilTypes.SEARCH_LAW_FAILURE:
        draft.request.search_law = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case JuridicoFacilTypes.GET_AREAS_SUBTOPICS_REQUEST:
        draft.request.areas_subtopics = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case JuridicoFacilTypes.GET_AREAS_SUBTOPICS_SUCCESS:
        draft.juridico.acervo = result?.data?.subtemas;
        draft.request.areas_subtopics = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case JuridicoFacilTypes.GET_AREAS_SUBTOPICS_FAILURE:
        draft.request.areas_subtopics = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case JuridicoFacilTypes.AREAS_TEMAS_REQUEST:
        draft.request.tema_area = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case JuridicoFacilTypes.AREAS_TEMAS_SUCCESS:
        draft.juridico.acervo = result?.data?.lista;
        draft.request.tema_area = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case JuridicoFacilTypes.AREAS_TEMAS_FAILURE:
        draft.request.tema_area = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case JuridicoFacilTypes.VIDEO:
        draft.juridico.video_show = video_ativo;
        break;
      case JuridicoFacilTypes.ACCEPT:
        draft.juridico.accept = accept;
        break;
      default:
    }
  });
};
export default reducer;
